import _styled2 from "styled-components";
import _styled from "styled-components";
var _excluded = ["style", "className", "getComboboxProps", "showIcon", "placeholder", "isOpen"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType, useLocale } from '@adsk/alloy-helpers';
import Icon from '@adsk/alloy-icon';
import theme from '@adsk/alloy-theme';
var SearchInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _T$translate, _T$translate2;

  var style = _ref.style,
      className = _ref.className,
      getComboboxProps = _ref.getComboboxProps,
      _ref$showIcon = _ref.showIcon,
      showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon,
      placeholderProp = _ref.placeholder,
      isOpen = _ref.isOpen,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useLocale = useLocale(function (_ref2) {
    var locale = _ref2.locale;
    return require("../../i18n/".concat(locale, ".json"));
  }),
      T = _useLocale.T;

  var defaultPlaceholder = isOpen ? (_T$translate = T.translate('SEARCH')) === null || _T$translate === void 0 ? void 0 : _T$translate.toString() : (_T$translate2 = T.translate('SELECT')) === null || _T$translate2 === void 0 ? void 0 : _T$translate2.toString();
  var placeholder = placeholderProp === undefined ? defaultPlaceholder : placeholderProp;
  var openMinWidth = '10ch';
  var closedMinWidth = "".concat(placeholder ? placeholder.length : 0, "ch");
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    className: className
  }, getComboboxProps(), {
    $_css: [{
      display: 'flex',
      flex: 'auto',
      alignItems: 'center',
      overflow: 'hidden'
    }, style]
  }), showIcon && /*#__PURE__*/React.createElement(Icon, {
    size: 20,
    type: Icon.TYPES.MAGNIFYING_GLASS,
    style: [{
      marginLeft: -2,
      marginRight: 2,
      color: theme.colors.charcoal500
    }]
  }), /*#__PURE__*/React.createElement(_StyledInput, _extends({
    ref: ref,
    "data-testid": 'Dropdown__input',
    placeholder: placeholder
  }, props, {
    $_css2: [_objectSpread({
      minWidth: isOpen ? openMinWidth : closedMinWidth,
      maxWidth: '100%',
      overflow: 'hidden',
      border: 'none',
      outline: 'none',
      color: theme.colors.charcoal900,
      backgroundColor: 'transparent'
    }, !isOpen && {
      cursor: 'pointer'
    }), theme.typography.labelMedium]
  })));
});
SearchInput.displayName = 'SearchInput';
SearchInput.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,

  /** Class applied to the root element */
  className: PropTypes.string,

  /** Input placeholder text */
  placeholder: PropTypes.string,

  /** Function to return props for the input element's parent */
  getComboboxProps: PropTypes.func.isRequired,

  /** Whether to show the search icon */
  showIcon: PropTypes.bool,

  /** Whether Dropdown menu is open */
  isOpen: PropTypes.bool.isRequired
};
export default SearchInput;

var _StyledDiv = _styled("div").withConfig({
  displayName: "SearchInput___StyledDiv",
  componentId: "sc-1vzomia-0"
})(["", ""], function (p) {
  return p.$_css;
});

var _StyledInput = _styled("input").withConfig({
  displayName: "SearchInput___StyledInput",
  componentId: "sc-1vzomia-1"
})(["", ""], function (p) {
  return p.$_css2;
});
//# sourceMappingURL=SearchInput.js.map